"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDefined = exports.getBaseFee = exports.wait = void 0;
const errors_1 = require("../dataEntities/errors");
const wait = (ms) => new Promise(res => setTimeout(res, ms));
exports.wait = wait;
const getBaseFee = async (provider) => {
    const baseFee = (await provider.getBlock('latest')).baseFeePerGas;
    if (!baseFee) {
        throw new errors_1.ArbSdkError('Latest block did not contain base fee, ensure provider is connected to a network that supports EIP 1559.');
    }
    return baseFee;
};
exports.getBaseFee = getBaseFee;
const isDefined = (val) => typeof val !== 'undefined' && val !== null;
exports.isDefined = isDefined;
